import { mapGetters, mapActions } from 'vuex'
import AnalystModule, { MODULE_NAME } from './index'

const AnalystMixin = {
  namespaced: AnalystModule.namespaced,
  computed: { ...mapGetters(MODULE_NAME, Object.keys(AnalystModule.getters)) },
  methods: { ...mapActions(MODULE_NAME, Object.keys(AnalystModule.actions)) }
}

export default AnalystMixin



// WEBPACK FOOTER //
// ./src/store/module/analyst/mixin.js